import img1 from "../assets/allcourses/allcourses1.jpg";
import img2 from "../assets/allcourses/allcourses2.jpg";
import img3 from "../assets/allcourses/allcourses3.jpg";
import img4 from "../assets/allcourses/allcourses4.jpg";
import img5 from "../assets/allcourses/allcourses5.jpg";

export const allCourses = [
  {
    id: 1,
    banner: img1,
    title: "User Experience (UX): The Ultimate Guide to Usability and UX",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,
    courseLectures: "13 Lectures | 58mins",
    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],
    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    banner: img2,
    title: "User Experience (UX): The Ultimate Guide to Usability and UX",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,

    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],

    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    banner: img3,
    title: "ImproveCommunication: Speak Smoothly, Clearly & Confidently",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,

    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],
    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    banner: img1,
    title: "User Experience (UX): The Ultimate Guide to Usability and UX",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,

    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],
    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    banner: img4,
    title: "User Experience (UX): The Ultimate Guide to Usability and UX",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,

    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],
    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    banner: img5,
    title: "I.T. Project Management for Beginners: A Step-by-Step Guide",
    duration: "6hr 24min | 2.6K Views",
    overview:
      "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
    price: "N10,000",
    showPrice: 10000,

    description: [
      "You've just landed on Vidom's highest rated course on user experience (UX). Thousands of user researchers and designers have used this course to kick-start their career in UX. You can do it, too.",
      "Gain hands-on practice in all the key areas of UX — from interviewing your users through to prototyping and usability testing your designs.",
      "Build a UX portfolio to boost your job prospects as you complete five real-world sample projects",
      "Gain industry-recognised certification by preparing for the BCS Foundation Certificate in User Experience.",
    ],
    requirements: [
      "You don't need a background in user experience, design or coding to take this course.",
      "This is a in-depth course.If you allocate 60-90 mins a day, and do all of the activities, it will take 2-3 weeks to complete.",
    ],
    learn: [
      "Bake UX into your workflow by following a proven, user centred design framework.",
      "Moderate a usability test and prioritise the observations.",
      "Uncover and describe users' mental models.",
      "Design and conduct online and offline card sorting sessions.",
      "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users.",
      "Design usability tests to measure time on task, success rate and user satisfaction",
      "Prepare for the BCS Foundation Certificate in User Experience.",
      "Plan field visits and user interviews to uncover user needs.",
      "Create personas, user stories, red routes and user journey maps.",
      "Choose appropriate schemes for classifying and organising information.",
      "Select appropriate user interface design patterns.",
      "Evaluate the usability of systems by applying usability heuristics.",
    ],
    courseDetails: "12 sections • 156 lectures • 12h 9m total length",
    courseDemograph: [
      " Anyone who wants to transition from their current job role to a career in user experience.",
      "User researchers or designers who want to build their user experience portfolio by applying their skills to a real world design project.",
      "Software developers who want to learn techniques for designing more engaging systems.",
      "Project managers and Scrum Masters who want a full lifecycle process for introducing usability into their design project.",
      "Interface designers who want to learn methods for testing and evaluating their designs.",
      "Web site designers who want to understand the principles of human-centred design. ",
      "Marketing managers who want to find out about the business and brand benefits of user experience. ",
      "Business analysts who want quick and effective tools for communicating requirements of users.",
    ],
    courseContent: [
      {
        heading: "Setting the Scene",
        courseLectures: "13 Lectures | 58mins",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
      {
        heading: "Going where the action is: Understanding  user in context",
        courseLectures: "15 Lectures | 1hr 10min",
        courseHiddenDetails: [
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
          {
            details: "How usability depends on the “context of use”",
            time: "08:20",
            hiddenDetails:
              "This lecture explains why context is so crucial to designing a good user experience. We also review why, if you're a member of a design team, you are not representative of the target audience. ",
          },
        ],
      },
    ],
  },
];

export function getCourses(title: string | undefined) {
  return allCourses.find((course) => course.title === title);
}
